class Event {
    constructor(listener, context, once) {
        this.listener = listener;
        this.context = context;
        this.once = once || false;
    }
}

export default class EventEmitter {
    constructor() {
        this.events = new Map();
    }
    once(eventName, listener) {
        this._addListener(eventName, listener, true);
        return this;
    }
    on(eventName, listener, once) {
        this._addListener(eventName, listener, once);
        return this;
    }
    off(eventName, listener) {
        this._removeListener(eventName, listener);
        return this;
    }
    emit(eventName) {
        const args = Array.prototype.slice.call(arguments, 1);
        return this._trigger(eventName, args);
    }
    listeners(eventName) {
        if (this.events.has(eventName)) {
            return this.events.get(eventName);
        } else {
            return [];
        }
    }
    _addListener(eventName, listener, once) {
        const event = new Event(listener, this, once);
        if (!this.events.has(eventName)) {
            this.events.set(eventName, [event]);
        } else {
            this.events.get(eventName).push(event);
        }
        return this;
    }
    _removeListener(eventName, listener) {
        const listeners = this.listeners(eventName);
        for (let i = 0, event; i < listeners.length; i++) {
            event = listeners[i];
            if (event.listener === listener) {
                listeners.splice(i, 1);
            }
        }
        return this;
    }
    _trigger(eventName, args) {
        const listeners = this.listeners(eventName);
        listeners.forEach(listener => {
            listener.listener.apply(this, args || []);
            if (listener.once) {
                this._removeListener(eventName, listener.listener);
            }
        });
        return this;
    }
}
